export default /* glsl */`
    vDepth = getLinearDepth(localPos);
`;
